import ButtonMenu from "../Buttons/ButtonMenu";
import LanguageFlag from "./LanguageFlag";

const LanguageSwitcher = ({
  language = "en",
  onChangeLanguage = () => {},
  colorButton = "secondary",
  sx = {},
  sxMenu = {},
  anchorOrigin = null,
  transformOrigin = null,
}) => {
  const languageOptions = [
    {
      icon: <LanguageFlag language="en" sx={{ mr: 0 }} />,
      label: "en",
      onClick: () => onChangeLanguage("en"),
    },
    {
      icon: <LanguageFlag language="es" sx={{ mr: 0 }} />,
      label: "es",
      onClick: () => onChangeLanguage("es"),
    },
  ];

  return (
    <ButtonMenu
      showLabel={false}
      options={languageOptions}
      iconButton={<LanguageFlag language={language || "en"} />}
      colorButton={colorButton}
      anchorOrigin={anchorOrigin}
      transformOrigin={transformOrigin}
      sx={sx}
      sxMenu={sxMenu}
    />
  );
};

export default LanguageSwitcher;
